// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"c9d0387c","834":"643d37ac"}[chunkId] + ".chunk.js";
};